module.exports = __webpack_public_path__ + "assets/img/step1-title.68581df6.svg";